<template lang="pug">
  e-form-group(
  :name="fieldName"
  inputType="suggestion[]"
  label="Вид деятельности"
    :model="fields"
      :options="options"
      :tabView="tabView"
      :formGroupStyle="formGroupStyle"
      :required="required"
  )
</template>
<script>
  import reportFieldMixin from '../../mixins/report-field-mixin'
  import {Storage, Burial} from '../../../../config/config'

  export default {
    mixins: [reportFieldMixin],
    name: 'actions-storage',
    created () {
      this.$set(this.fields, this.fieldName, [Storage, Burial])
    },
    computed: {
      fieldName () {
        return 'actions'
      },
      options () {
        return [
          {id: Storage, name: 'Хранение'},
          {id: Burial, name: 'Захоронение'}
        ]
      }
    }
  }
</script>
